export default __webpack_public_path__ + "static/BannerJsonImageAndTextWithAction_ImageLeftDark-6181917cc899a35950e55ec7835e023c.jpg";